export default "<template>\r\n  <v-subheader>Subheader</v-subheader>\r\n</template>\r\n";